<template>
  <nav class="breadcrumb-wrapper container" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li
        class="breadcrumb-item"
        v-for="item of items"
        :key="item.id"
      >
        <b-link :to="item.to">{{item.text}}</b-link>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumbs",
  computed: {
    items() {
      const items = [];
      const bcrumbs = this.$store.getters["breadcrumbs/getBreadcrumbsRoutes"];
      let item = { text: "Home", to: "/" };
      items.push(item);
      bcrumbs.forEach((bcrumb) => {
        item = { text: bcrumb.name, to: bcrumb.route_link };
        items.push(item);
      });
      const curr = this.$store.getters["breadcrumbs/getBreadcrumbsCurrent"];
      item = { text: curr, active: true };
      items.push(item);
      return items;
    },
  },
};
</script>
